// extracted by mini-css-extract-plugin
export default {"root":"styles-root-c8b941","links":"styles-links-dd56f1","link":"styles-link-d63d43"};